import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resultado")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
  component: () => null,
});
